module.exports = __webpack_public_path__ + "img/fa-light-300.bf9fa6d.svg";